import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../store/rootStore";

const ShowFormHeaders:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {allChosenSubjects} = rootStore.subjectStore;

  return (
    <div className='row headers'>
      <div className="header"></div>
      {allChosenSubjects.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1).map(subject =>
        <div key={subject.slug} className={`header subject-${subject.slug}`}>
          {subject.name}
        </div>
      )}
    </div>
  )
});

export default ShowFormHeaders;
